import { courseType } from "../../../../../constants";
import { useCheckoutCourse } from "../hooks/useCheckoutCourse";
import { OnsiteCourseCheckout } from "./OnsiteCourseCheckout";

export function CourseCheckoutInformation() {
	const { course } = useCheckoutCourse();

	if (!course) {
		return null;
	}

	if (course.type === courseType.ONSITE) {
		return <OnsiteCourseCheckout />;
	}

	return null;
}
